import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { DeleteNodePayload, TemplateEdgeT, TemplateNodeT } from '../../../types/skeleton-template-builder.type';
import { selectedNodeIdAtom, templateEdgesAtom, templateNodesAtom } from '../template-atoms';
export const deleteNodeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<DeleteNodePayload, void> => {
  let deletedNode: TemplateNodeT | undefined;
  let deletedEdges: TemplateEdgeT[] = [];
  let wasSelected = false;
  return {
    execute: payload => {
      const {
        nodeId
      } = payload;
      const nodes = get(templateNodesAtom);
      const edges = get(templateEdgesAtom);
      deletedNode = nodes.find(n => n.id === nodeId);
      if (!deletedNode) return;
      deletedEdges = edges.filter(e => e.sourceNodeId === nodeId || e.targetNodeId === nodeId);
      wasSelected = get(selectedNodeIdAtom) === nodeId;
      set(templateNodesAtom, nodes.filter(n => n.id !== nodeId));
      set(templateEdgesAtom, edges.filter(e => e.sourceNodeId !== nodeId && e.targetNodeId !== nodeId));
      if (wasSelected) {
        set(selectedNodeIdAtom, null);
      }
    },
    undo: () => {
      if (!deletedNode) return;
      set(templateNodesAtom, [...get(templateNodesAtom), deletedNode]);
      set(templateEdgesAtom, [...get(templateEdgesAtom), ...deletedEdges]);
      if (wasSelected) {
        set(selectedNodeIdAtom, deletedNode.id);
      }
    }
  };
};